// Role-based permissions helper.
// Roles: admin | danisman | operasyon
//
// Admin      → full access
// Danışman   → tüm operasyonel modüller, private note görebilir, ödeme oluşturamaz, kullanıcı yönetimi yok
// Operasyon  → başvurular/randevular/ödemeler/mesajlar/görevler, private note göremez, danışan silemez, ayarlar salt-okunur

const RULES = {
  admin: {
    modules: [
      "dashboard",
      "clients",
      "applications",
      "meetings",
      "appointments",
      "works",
      "tasks",
      "payments",
      "forms",
      "messages",
      "reports",
      "settings",
    ],
    canDeleteClient: true,
    canCreatePayment: true,
    canManageUsers: true,
    canSeePrivateNotes: true,
    canEditClient: true,
    canManageWorks: true,
  },
  danisman: {
    modules: [
      "dashboard",
      "clients",
      "applications",
      "meetings",
      "appointments",
      "works",
      "tasks",
      "forms",
      "messages",
      "reports",
      "settings",
    ],
    canDeleteClient: false,
    canCreatePayment: false,
    canManageUsers: false,
    canSeePrivateNotes: true,
    canEditClient: true,
    canManageWorks: true,
  },
  operasyon: {
    modules: [
      "dashboard",
      "clients",
      "applications",
      "appointments",
      "tasks",
      "payments",
      "forms",
      "messages",
      "reports",
      "settings",
    ],
    canDeleteClient: false,
    canCreatePayment: true,
    canManageUsers: false,
    canSeePrivateNotes: false,
    canEditClient: true,
    canManageWorks: false,
  },
};

const DEFAULT_ROLE = "operasyon";

export function permsFor(user) {
  const role = (user && user.role) || DEFAULT_ROLE;
  return RULES[role] || RULES[DEFAULT_ROLE];
}

export function canAccessModule(user, moduleKey) {
  return permsFor(user).modules.includes(moduleKey);
}
